<template>
    <span>
        <span v-if="showToggle" class="toggle" v-html="toggleIndicator" @click.prevent="toggleState"></span>
        <span v-if="!isExpanded" v-html="preview" @click.prevent="toggleState"></span>
        <span v-if="isExpanded" v-html="text" style="white-space: pre-wrap;"></span>
    </span>
</template>

<script>
    const maxChars = 40;

    export default {
        props: ["text", "expanded"],
        data() {
            return {
                isExpanded: this.text.length > maxChars && !!this.expanded
            }
        },
        methods: {
            toggleState() {
                if(!this.showToggle) return;
                this.isExpanded = !this.isExpanded;
            }
        },
        computed: {
            showToggle() {
                return this.isExpanded || this.text.length > maxChars;
            },
            toggleIndicator() {
                return this.isExpanded ? '-' : '+';
            },
            displayText() {
                return this.isExpanded ? this.text : this.preview;
            },
            preview() {
                var text = this.text;
                if(!text) return '';

                if(text.length <= maxChars) return text;
                return text.substr(0, text.lastIndexOf(" ", maxChars)) + '...';
            }
        }
    }
</script>
<style lang="scss" scoped>
@import "../../scss/amf-variables";
    .toggle
    {
        font-size: 1.1em;
        font-weight: bold;
        color: $linkColor;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/framework/primitives/AmfExpandableText.vue